import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { ProfileService } from '../profile.service';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
declare var $: any;
// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
	selector: 'app-update-email',
	templateUrl: './update-email.component.html',
	styleUrls: ['./update-email.component.css']
})
export class UpdateEmailComponent implements OnInit {
	emailFormControl = new FormControl('', [
		Validators.pattern(EMAIL_REGEX)]);

	public email: any;
	public raw_id: string;
	public is_email_update: any;
	public is_verify: any;
	public message: any;
	public is_success: boolean;
	public load_page: boolean;
	constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
		private localStorageService: LocalStorageService, private router: Router,
		private profileService: ProfileService, private dialog: MatDialog) {
		this.sharedService.setHeaderTitle('default_page');
		this.activatedRoute.params.subscribe((params: Params) => {
			if (params['account_id'] != undefined && params['token'] != undefined) {
				this.is_verify = true;
				let that = this;
				that.raw_id = params['account_id'];
				let data = { 'rawId': params['account_id'], 'token': params['token'] };
				setTimeout(function () {
					that.sharedService.setHeaderTitle('email_verify');
				}, 10);
				this.profileService.verifyEmail(data).then(res => {
					this.load_page = true;
					if (res.status == 'success') {
						this.message = res.message;
						this.is_success = true;
					} else {
						this.message = res.message;
						this.is_success = false;
					}
				});
			} else {
				this.is_verify = false;
				if (this.localStorageService.get('token') != null) {
					this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
						.then(res => {
							if (res.status == 'success' && res.isTerminated == false) {
								if (!res.isEnrolled) {
									this.router.navigate(['./dashboard']);
								} else {
									window.scrollTo(0, 0);
									let that = this;
									this.raw_id = res.results[0].personal[0].id;
									that.sharedService.setHeaderErrorMessage('update_email', false, 'notification error', '');
									setTimeout(function () {
										that.sharedService.setHeaderTitle('update_email');
									}, 10);
								}
							} else {
								this.localStorageService.remove('token');
								this.localStorageService.set('returnUrl', 'Profile/AccountSetting/UpdateEmail');
								this.router.navigate(['./sign-in']);
							}
						});
				} else {
					this.localStorageService.set('returnUrl', 'Profile/AccountSetting/UpdateEmail');
					this.router.navigate(['./sign-in']);
				}
			}
		});
	}

	emailValidate(event: any) {
		if (this.email.match(EMAIL_REGEX)) {
			this.is_email_update = true;
		} else {
			this.is_email_update = false;
		}
	}

	changeEmail() {
		this.sharedService.setHeaderErrorMessage('update_email', false, 'notification error', '');
		let data = { 'token': this.localStorageService.get('token'), 'email': this.email, 'acc_setting': true };
		this.profileService.updateEmail(data).then(res => {
			if (res.status == 'success') {
				let dialogRef = this.dialog.open(UpdateEmailAddress, {
					data: { message: res.message, raw_id: this.raw_id }
				});
			} else {
				if (res.type == 'timeup') {
					this.router.navigate(['./Profile/AccountSetting/SignIn']);
				} else {
					this.sharedService.setHeaderErrorMessage('update_email', true, 'notification error', res.message);
				}
			}
		});
	}

	ngOnInit() {
	}

}

@Component({
	selector: 'update-email-address',
	template: `<div class="dialog-main"><h3 class="text-center">Info</h3><p>{{message}}</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true" (click)="ok()">Okay</button></div>`,
})
export class UpdateEmailAddress {
	public message: any;
	public raw_id: string;
	constructor(private activatedRoute: ActivatedRoute, private dialog: MatDialog, private sharedService: SharedService, private localStorageService: LocalStorageService, private router: Router, public dialogRef: MatDialogRef<UpdateEmailAddress>, @Inject(MAT_DIALOG_DATA) public data: any) {
		this.message = this.data.message;
		this.raw_id = this.data.raw_id;
	}
	ok() {
		this.router.navigate(['./contact-info/']);
	}
}



// WEBPACK FOOTER //
// ./src/app/profile/update-email/update-email.component.ts